App.prototype.toggleDisabledBasketFields = function (disabled = true) {
    return;
    const fields = [
        document.querySelectorAll('[name="delivery_type_id"]'),
        document.querySelectorAll('[name="payment_method_id"]'),
        document.querySelectorAll('.payment-form button[type="submit"]'),
        // document.querySelectorAll('.product-box button.increase'),
        // document.querySelectorAll('.product-box button.decrease'),
    ];

    fields.forEach(function (fieldGroup) {
        fieldGroup.forEach(function (el) {
            el.disabled = disabled;
        });
    });
};
